module.exports = __webpack_public_path__ + "static/img/review_one.1cc9c0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activityforecast2024/review_one.png
// module id = FVHw
// module chunks = 0